// Module
var code = "<template> <span if.bind=\"text && !isError\">${text}</span> <small else><i class=\"text-default\">${exceptionMessage}</i></small> </template> ";
// Exports
export default code;